import React from 'react';
// taken from https://stackoverflow.com/a/18473154
function polarToCartesian(
  centerX: number,
  centerY: number,
  radius: number,
  angleInDegrees: number,
) {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians),
  };
}

function describeArc(
  x: number,
  y: number,
  radius: number,
  startAngle: number,
  endAngle: number,
) {
  const start = polarToCartesian(x, y, radius, endAngle);
  const end = polarToCartesian(x, y, radius, startAngle);
  const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
  return [
    'M',
    start.x,
    start.y,
    'A',
    radius,
    radius,
    0,
    largeArcFlag,
    0,
    end.x,
    end.y,
  ].join(' ');
}

const Arc = ({
  className,
  strokeWidth,
  viewBoxSize,
  angle,
}: {
  className: string;
  strokeWidth: number;
  viewBoxSize: number;
  angle: number;
}) => {
  const d = describeArc(0, 0, (viewBoxSize - strokeWidth) / 2, 0, angle);
  const viewBox = `-${viewBoxSize / 2} -${
    viewBoxSize / 2
  } ${viewBoxSize} ${viewBoxSize}`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      className={className}
    >
      <path strokeWidth={strokeWidth} d={d} />
    </svg>
  );
};

Arc.displayName = 'Arc';

export { Arc };
